import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ThemeProvider } from '@/components/layout/ThemeProvider';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import Layout from '@/components/layout/Layout';
import HomePage from '@/pages/HomePage';
import LessonPage from '@/pages/LessonPage';

/**
 * Корневой компонент приложения
 * Настраивает провайдеры и маршрутизацию
 */
function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark" storageKey="git-lessons-theme">
        {/* Toast notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#1e293b',
              color: '#e2e8f0',
              border: '1px solid #334155',
            },
          }}
        />

        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="lesson/:lessonId" element={<LessonPage />} />
            <Route path="module/:moduleId/lesson/:lessonId" element={<LessonPage />} />
          </Route>
        </Routes>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
